import App from './classes/App';

new App();

